export default function FoundingMemberIcon({ size = 16, style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 272 272"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "inline-block", verticalAlign: "top", ...style }}
    >
      <path
        d="M132 2.3094C134.475 0.880338 137.525 0.880339 140 2.3094L249.779 65.6906C252.255 67.1197 253.779 69.7607 253.779 72.6188V199.381C253.779 202.239 252.255 204.88 249.779 206.309L140 269.691C137.525 271.12 134.475 271.12 132 269.691L22.2205 206.309C19.7453 204.88 18.2205 202.239 18.2205 199.381V72.6188C18.2205 69.7607 19.7453 67.1197 22.2205 65.6906L132 2.3094Z"
        fill="#2F788B"
      />
      <path
        d="M157.673 40.6729L137.293 29.4839V242.516L157.673 230.847V105.36L183.247 181.038L207.645 117.333L208.847 201.002L229.152 189.856V82.3152L205.016 68.3801L184.67 124.331L157.673 40.6729Z"
        fill="#ffffff"
      />
      <path
        d="M124.934 34.1528L42.8481 81.5452V190.018L63.2971 201.824V149.692L114.479 120.142V96.5764L63.2971 126.126V93.7934L124.934 58.2073V34.1528Z"
        fill="#ffffff"
      />
    </svg>
  );
}
